/* eslint-disable */
export const region11Barangays = [
    {
        CITY: 'ASUNCION',
        BARANGAY: 'BINANCIAN',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'BUAN',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'BUCLAD',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'CABAYWA',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'CAMANSA',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'CAMBANOGOY (POB.)',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'CAMONING',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'CANATAN',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'DONA ANDREA',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'DOÑA ANDREA',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'MAGATOS',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'NAPUNGAS',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'NEW BANTAYAN',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'NEW LOON',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'NEW SANTIAGO',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'PAMACAUN',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'SAGAYEN',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'ASUNCION',
        BARANGAY: 'SONLON',
    },
    {
        CITY: 'BRAULIO-E.-DUJALI',
        BARANGAY: 'CABAY-ANGAN',
    },
    {
        CITY: 'BRAULIO-E.-DUJALI',
        BARANGAY: 'DUJALI',
    },
    {
        CITY: 'BRAULIO-E.-DUJALI',
        BARANGAY: 'MAGUPISING',
    },
    {
        CITY: 'BRAULIO-E.-DUJALI',
        BARANGAY: 'NEW CASAY',
    },
    {
        CITY: 'BRAULIO-E.-DUJALI',
        BARANGAY: 'TANGLAW',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'ALEJAL',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'ANIBONGAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'ASUNCION (CUATRO-CUATRO)',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'CEBULANO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'ISING (POB.)',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MABAUS',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MANGALCAL',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MINDA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'NEW CAMILING',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'TABA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'TIBULAO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'TUGANAY',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'DACUDAO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'DATU BALONG',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'IGANGON',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'KIPALILI',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'LIBUTON',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MAMANGAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MONTE DUJALI',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'PINAMUNO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SABANGAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SAWATA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BALAGUNAN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BOBONGON',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CASIG-ANG',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'KIMAMON',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'KINAMAYAN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'LA LIBERTAD',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'LUNGAOG',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'MAGWAWA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'NEW KATIPUNAN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'NEW VISAYAS',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'PANTARON',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'TALOMO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'TIBAL-OG (POB.)',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'TULALIAN',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'ADECOR',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'AUMBAY',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'AUNDANAO',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'BALET',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'BANDERA',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'CALICLIC (DANGCA-AN)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'CAMUDMUD',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'CATAGMAN',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'CAWAG',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'DEL MONTE',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'GUILON',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'KANAAN',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'KINAWITNON',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'LIBUAK',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'LICUP',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'LIMAO',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'LINOSUTAN',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'MAMBAGO-A',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'MAMBAGO-B',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'MIRANDA (POB.)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'MONCADO (POB.)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'PANGUBATAN (TALICOD I)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'PENAPLATA (POB.)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'PEÑAPLATA (POB.)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'POBLACION (KAPUTIAN)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'SAN ISIDRO (BABAK)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'SAN ISIDRO (KAPUTIAN)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'SAN JOSE (SAN LAPUZ)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'SAN MIGUEL (MAGAMONO)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'SAN REMIGIO',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'SION (ZION)',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'TAGBAY',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'TAGBITAN-AG',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'TAGDALIAO',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'TAGPOPONGAN',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'ISLAND-GARDEN-OF-SAMAL',
        BARANGAY: 'TORIL',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'CAPUNGAGAN',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'FLORIDA',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'GABUYAN',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'GUPITAN',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'MABANTAO',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'MAMACAO',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'MANIKI (POBLACION)',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'SAMPAO',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'SAMPAO (BIENVENIDA)',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'SEMONG',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'SEMONG (SAMPAO)',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'SUA-ON',
    },
    {
        CITY: 'KAPALONG',
        BARANGAY: 'TIBURCIA',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'CABIDIANAN',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'CARCOR',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'DEL MONTE',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'EL SALVADOR',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'LIMBA-AN',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'MACGUM',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'MAMBING',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'MESAOY',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'NEW BOHOL',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'NEW CORTEZ',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'NEW SAMBOG',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'PATROCENIO',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'NEW-CORELLA',
        BARANGAY: 'SUAWON',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'A. O. FLOIRENDO',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'CACAO',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'CAGANGOHAN',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'CONSOLACION',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'DAPCO',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'DATU ABDUL DADIA',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'GREDU (POB.)',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'J.P. LAUREL',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'KASILAK',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'KATUALAN',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'KIOTOY',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'LITTLE PANAY',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'LOWER PANAGA (ROXAS)',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'MABUNAO',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'MADUAO',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'MALATIVAS',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'MANAY',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'NANYO',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'NEW MALAGA (DALISAY)',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'NEW MALITBOG',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'NEW PANDAN (POB.)',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'NEW VISAYAS',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'SANTO NIÑO (POB.)',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'SINDATON',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'SOUTHERN DAVAO',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'TAGPORE',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'TIBUNGOL',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'UPPER LICANAN',
    },
    {
        CITY: 'PANABO',
        BARANGAY: 'WATERFALL',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'APOKON',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'BINCUNGAN',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'BUSAON',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'CANOCOTAN',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'CUAMBOGAN',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'LA FILIPINA',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'LIBOGANON',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'MADAUM',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'MAGDUM',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'MAGUGPO EAST',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'MAGUGPO NORTH',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'MAGUGPO POBLACION',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'MAGUGPO SOUTH',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'MAGUGPO WEST',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'MANKILAM',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'NEW BALAMBAN',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'NUEVA FUERZA',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'PAGSABANGAN',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'PANDAPAN',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'SAN MIGUEL (CAMP 4)',
    },
    {
        CITY: 'TAGUM',
        BARANGAY: 'VISAYAN VILLAGE',
    },
    {
        CITY: 'TALAINGOD',
        BARANGAY: 'DAGOHOY',
    },
    {
        CITY: 'TALAINGOD',
        BARANGAY: 'PALMA GIL',
    },
    {
        CITY: 'TALAINGOD',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'ALEGRE',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'ALTA VISTA',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'BITAUG',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'DARAPUAY',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'DOLO',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'EMAN',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'KINUSKUSAN',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'LINAWAN',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'MABUNGA',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'MANAGA',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'MARBER',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'NEW CLARIN (MIRAL)',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'POBLACION DOS',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'SIBAYAN',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'TINONGTONGAN',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'BANSALAN',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'ACACIA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'AGDAO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'ALAMBRE',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'ALEJANDRA NAVARRO (LASANG)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'ALFONSO ANGLIONGTO SR.',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'ANGALAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'ATAN-AWE',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BAGANIHAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BAGO APLAYA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BAGO GALLERA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BAGO OSHIRO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BAGUIO (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BALENGAENG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BALIOK',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BANGKAS HEIGHTS',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BANTOL',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARACATAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 10-A (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 11-B (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 12-B (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 13-B (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 14-B (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 15-B (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 16-B (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 17-B (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 18-B (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 19-B (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 1-A (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 20-B (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 21-C (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 22-C (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 23-C (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 24-C (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 25-C (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 26-C (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 27-C (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 28-C (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 29-C (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 2-A (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 30-C (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 31-D (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 32-D (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 33-D (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 34-D (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 35-D (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 36-D (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 37-D (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 38-D (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 39-D (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 3-A (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 40-D (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 4-A (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 5-A (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 6-A (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 7-A (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 8-A (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BARANGAY 9-A (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BIAO ESCUELA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BIAO GUIANGA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BIAO JOAQUIN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BINUGAO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BUCANA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BUDA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BUHANGIN (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'BUNAWAN (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CABANTIAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CADALIAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CALINAN (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CALLAWA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CAMANSI',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CATALUNAN GRANDE',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CATALUNAN PEQUENO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CATALUNAN PEQUEÑO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CATIGAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CENTRO (SAN JUAN)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'COLOSAS',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'COMMUNAL',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'CROSSING BAYABAS',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'DACUDAO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'DALAG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'DALAGDAG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'DALIAO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'DALIAON PLANTATION',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'DATU SALUMAY',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'DOMINGA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'DUMOY',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'EDEN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'FATIMA (BENOWANG)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'GATUNGAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'GOV. PACIANO BANGOY',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'GOV. VICENTE DUTERTE',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'GUMALANG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'GUMITAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'ILANG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'INAYANGAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'INDANGAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'KAP. TOMAS MONTEVERDE',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'KAP. TOMAS MONTEVERDE SR.',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'KILATE',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'LACSON',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'LAMANAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'LAMPIANAO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'LANGUB',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'LAPU-LAPU',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'LEON GARCIA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'LEON GARCIA SR.',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'LIZADA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'LOS AMIGOS',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'LUBOGAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'LUMIAD',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MA-A',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MAGTUOD',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MALABOG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MALAGOS',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MALAMBA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MANAMBULAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MANDUG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MANUEL GUIANGA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MAPULA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MARAPANGI',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MARILOG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MATINA APLAYA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MATINA BIAO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MATINA CROSSING',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MATINA PANGI',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MEGKAWAYAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MINTAL',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MUDIANG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'MULIG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'NEW CARMEN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'NEW VALENCIA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'PAMPANGA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'PANACAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'PANALUM',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'PANDAITAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'PANGYAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'PAQUIBATO (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'PARADISE EMBAK',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'RAFAEL CASTILLO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'RIVERSIDE',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SALAPAWAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SALAYSAY',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SALOY',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SAN ISIDRO (LICANAN)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SASA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SIBULAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SIRAWAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SIRIB',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SUAWAN (TULI)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SUBASTA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'SUMIMAO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TACUNAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TAGAKPAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TAGLUNO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TAGURANO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TALANDANG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TALOMO (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TALOMO RIVER',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TAMAYONG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TAMBOBONG',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TAMUGAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TAPAK',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TAWAN-TAWAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TIBULOY',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TIBUNGCO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TIGATTO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TORIL (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TUGBOK (POB.)',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'TUNGAKALAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'UBALDE',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'ULA',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'VICENTE HIZON SR.',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'WAAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'WANGAN',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'WILFREDO AQUINO',
    },
    {
        CITY: 'DAVAO',
        BARANGAY: 'WINES',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'BALUTAKAY',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'CLIB',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'GUIHING',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'GUIHING APLAYA',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'HAGONOY CROSSING',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'KIBUAYA',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'LANURO',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'LAPULABAO',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'LELING',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'MALABANG DAMSITE',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'MALIIT DIGOS',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'NEW QUEZON',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'PALIGUE',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SACUB',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN GUILLERMO',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'SINAYAWAN',
    },
    {
        CITY: 'HAGONOY',
        BARANGAY: 'TOLOGAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'BACUNGAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'BALNATE',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'BARAYONG',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'BLOCON',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'DALAWINON',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'DALUMAY',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'GLAMANG',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'KANAPULO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'KASUGA',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'LOWER BALA',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'MAIBO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'MALAWANIT',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'MALONGON',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'NEW ILOCOS',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'NEW OPON',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'TACUL',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'UPPER BALA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'ASTORGA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'CORONON',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'DARONG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'INAWAYAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'JOSE RIZAL',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MATUTUNGAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MELILIA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SALIDUCON',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SIBULAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SINORON',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TAGABULI',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TIBOLO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TUBAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'APLAYA',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'BALABAG',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'BINATON',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'COLORADO',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'DAWIS',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'DULANGAN',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'GOMA',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'IGPIT',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'KAPATAGAN (RIZAL)',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'KIAGOT',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'LUNGAG',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'MATTI',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'RUPARAN',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'SAN JOSE (BALUTAKAY)',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'SAN MIGUEL (ODACA)',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'SINAWILAN',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'SOONG',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'TIGUMAN',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'TRES DE MAYO',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'ZONE 1 (POB.)',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'ZONE 2 (POB.)',
    },
    {
        CITY: 'DIGOS',
        BARANGAY: 'ZONE 3 (POB.)',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'ABNATE',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'BAGONG NEGROS',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'BALASIAO',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'BULOL-SALO',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'BUNOT',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'COGON-BACACA',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'DAPOK',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'IHAN',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'KIBONGBONG',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'KIMLAWIS',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'KISULAN',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'LATI-AN',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'MANUAL',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'MARAGA-A',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'MOLOPOLO',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'NEW SIBONGA',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'PANAGLIB',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'PASIG',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'POCALEEL',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'TACUB',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'TACUL',
    },
    {
        CITY: 'KIBLAWAN',
        BARANGAY: 'WATERFALL',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'BOLTON',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'BULACAN',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'CAPUTIAN',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'IBO',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'KIBLAGON',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'LAPU-LAPU (LAPLA)',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'NEW BACLAYON',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'PITU',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'RIZAL (PARAME)',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MALALAG',
        BARANGAY: 'TAGANSULE',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'ASBANG',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'ASINAN',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'BANGKAL',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'BUAS',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'BURI',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'CABLIGAN (MANAGA)',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'CAMANCHILES',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'CEBOZA',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'COLONSABAK',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'DONGAN-PEKONG',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'KABASAGAN',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'KAPOK',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'KIBAO',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'LA SUERTE',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'LANGA-AN',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'LOWER MARBER',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'NEW KATIPUNAN',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'NEW MURCIA',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'NEW VISAYAS',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'SABOY',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'SAUB',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'SINARAGAN',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'SINAWILAN',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'TAMLANGON',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'TIBONGBONG',
    },
    {
        CITY: 'MATANAO',
        BARANGAY: 'TOWAK',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'ALMENDRAS (POB.)',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'DON SERGIO OSMENA',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'DON SERGIO OSMENA SR.',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'HARADA BUTAI',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'LOWER KATIPUNAN',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'LOWER LIMONZO',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'LOWER MALINAO',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'N C ORDANEZA DISTRICT (POB.)',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'NORTHERN PALIGUE',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'PALILI',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'PIAPE',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'PUNTA PIAPE',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'QUIRINO DISTRICT (POB.)',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'SOUTHERN PALIGUE',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'TULOGAN',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'UPPER LIMONZO',
    },
    {
        CITY: 'PADADA',
        BARANGAY: 'UPPER MALINAO',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'BALASINON',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'BUGUIS',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'CARRE',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'CLIB',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'HARADA BUTAI',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'KIBLAGON',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'LABON',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'LAPERAS',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'LAPLA',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'LITOS',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'LUPARAN',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'MCKINLEY',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'NEW CEBU',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'PALILI',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'PARAME',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'SOLONGVALE',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'TAGOLILONG',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'TALA-O',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'TALAS',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'TANWALANG',
    },
    {
        CITY: 'SULOP',
        BARANGAY: 'WATERFALL',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'BAGONGON',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'GABI',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'LAGAB',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'MANGAYON',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'MAPACA',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'MAPARAT',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'NEW ALEGRIA',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'NGAN',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'PANANSALAN',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'SIOCON',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'TAMIA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'ANITAPAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CABUYUAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CADUNAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CUAMBOG (POB.)',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'GOLDEN VALLEY (MARAUT)',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'LIBODON',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'PANGIBIRAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'PINDASAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'TAGNANAN (MAMPISING)',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'AMOR CRUZ',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'AMPAWID',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'ANDAP',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'ANITAP',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'BANBANON',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'BELMONTE',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'BINASBAS',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'BULLUCAN',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'CEBULIDA',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'DATU AMPUNAN',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'DATU DAVAO',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'DONA JOSEFA',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'EL KATIPUNAN',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'IL PAPA',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'INACAYAN',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'KALIGUTAN',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'KAPATAGAN',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'KIDAWA',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'KILAGDING',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'KIOKMAY',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'LAAC (POB.)',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'LANGTUD',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'LONGANAPAN',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'MACOPA',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'MANGLOY',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'MELALE',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'NAGA',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'NEW BETHLEHEM',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'PANAMOREN',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'SABUD',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'SANTA EMILIA',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'LAAK',
        BARANGAY: 'SISIMON',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'ANIBONGAN',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'ANISLAGAN',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'BINUANGAN',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'BUCANA',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'CALABCAB',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'DUMLAN',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'ELIZALDE (SOMIL)',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'GUBATAN',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'HIJO',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'KINUBAN',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'LANGGAM',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'LAPU-LAPU',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'LIBAY-LIBAY',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'LIMBO',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'LUMATAB',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'MAGANGIT',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'MALAMODAO',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'MANIPONGOL',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'MAPAANG',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'MASARA',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'NEW ASTURIAS',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'NEW BARILI',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'NEW LEYTE',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'NEW VISAYAS',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'PANANGAN',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'PANGI (GAUDENCIO ANTONIO)',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'PANIBASAN',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'PANORAON',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'SANGAB',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'TAGBAROS',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'TAGLAWIG',
    },
    {
        CITY: 'MACO',
        BARANGAY: 'TERESA',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'BAHI',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'CAMBAGANG',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'CORONOBE',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'LAHI',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'LANGGAWISAN',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'MABUGNAO',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'MAGCAGONG',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'MAPAWA',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'MARAGUSAN (POB.)',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'MAUSWAGON',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'NEW ALBAY',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'NEW KATIPUNAN',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'NEW MAN-AY',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'NEW PANAY',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'PALOC',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'PAMINTARAN',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'PARASANON',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'TALIAN',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'TANDIK',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'MARAGUSAN',
        BARANGAY: 'TUPAZ',
    },
    {
        CITY: 'MAWAB',
        BARANGAY: 'ANDILI',
    },
    {
        CITY: 'MAWAB',
        BARANGAY: 'BAWANI',
    },
    {
        CITY: 'MAWAB',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'MAWAB',
        BARANGAY: 'MALINAWON',
    },
    {
        CITY: 'MAWAB',
        BARANGAY: 'NUEVA VISAYAS',
    },
    {
        CITY: 'MAWAB',
        BARANGAY: 'NUEVO ILOCO',
    },
    {
        CITY: 'MAWAB',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAWAB',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'MAWAB',
        BARANGAY: 'SAOSAO',
    },
    {
        CITY: 'MAWAB',
        BARANGAY: 'SAWANGAN',
    },
    {
        CITY: 'MAWAB',
        BARANGAY: 'TUBORAN',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'AWAO',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'BABAG',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'BANLAG',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'BAYLO',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'CASOON',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'HAGUIMITAN',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'INAMBATAN',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'MACOPA',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'MAMUNGA',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'MOUNT DIWATA',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'NABOC',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'OLAYCON',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'PASIAN (SANTA FILOMENA)',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'TUBO-TUBO (NEW DEL MONTE)',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'MONKAYO',
        BARANGAY: 'UPPER ULIP',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'BANAGBANAG',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'BANGLASAN',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'BANKEROHAN NORTE',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'BANKEROHAN SUR',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'CAMANSI',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'CAMANTANGAN',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'CANIDKID',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'DAUMAN',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'LEBANON',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'LINOAN',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'MAYAON',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'NEW CALAPE',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'NEW CEBULAN (SAMBAYON)',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'NEW DALAGUETE',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'NEW VISAYAS',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'PROSPERIDAD',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MONTEVISTA',
        BARANGAY: 'TAPIA',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'ANISLAGAN',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'ANTIQUERA',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'CABACUNGAN',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'CABIDIANAN',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'LIBASAN',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'LINDA',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'MAGADING',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'MANAT',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'MATILO',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'MIPANGI',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'NEW DAUIS',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'NEW SIBONGA',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'OGAO',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'PANGUTOSAN',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'SANTO NINO (KAO)',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'SASA',
    },
    {
        CITY: 'NABUNTURAN',
        BARANGAY: 'TAGNOCON',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'ANDAP',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'BANTACAN',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'BATINAO',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'CABINUANGAN (POB.)',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'CAMANLANGAN',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'COGONON',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'KAHAYAG',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'MAGANGIT',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'MANURIGAO',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'PAGSABANGAN',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'PANAG',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'NEW-BATAAN',
        BARANGAY: 'TANDAWAN',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'ARAIBO',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'BONGABONG',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'BONGBONG',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'KINGKING (POB.)',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'LAS ARENAS',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'MAGNAGA',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'MATIAO',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'NAPNAPAN',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'P. FUENTES',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'TAGDANGUA',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'TAG-UGPO',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'TAMBONGON',
    },
    {
        CITY: 'PANTUKAN',
        BARANGAY: 'TIBAGON',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BASIAWAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BUCA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CADAATAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'DATU DALIGASAO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'DATU INTAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'KIDADAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'KINILIDAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'KISULAD',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MALALAG TUBIG',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MAMACAO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'OGPAO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'PONGPONG',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'TANGLAD',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'BALUNTAYA',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'CALIAN',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'DALUPAN',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'KINANGA',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'KIOBOG',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'LANAO',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'LAPUAN',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'LAWA (POB.)',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'LINADASAN',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'NORTH LAMIDAN',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'NUEVA VILLA',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'SOUTH LAMIDAN',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'TALAGUTONG (POB.)',
    },
    {
        CITY: 'DON-MARCELINO',
        BARANGAY: 'WEST LAMIDAN',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'BALANGONAN',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'BUGUIS',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'BUKID',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'BUTUAN',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'BUTULAN',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'CABURAN BIG',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'CABURAN SMALL (POB.)',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'CAMALIAN',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'CARAHAYAN',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'CAYAPONGA',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'CULAMAN',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'KALBAY',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'KITAYO',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'MAGULIBAS',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'MALALAN',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'MANGILE',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'MARABUTUAN',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'MEYBIO',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'MOLMOL',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'NUING',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'PATULANG',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'QUIAPO',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'SUGAL',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'TABAYON',
    },
    {
        CITY: 'JOSE-ABAD-SANTOS',
        BARANGAY: 'TANUMAN',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'BITO',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'BOLILA',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'BUHANGIN',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'CULAMAN',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'DATU DANWATA',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'DEMOLOC',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'FELIS',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'FISHING VILLAGE (FISHERMAN\'S VILLAGE)',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'KIBALATONG',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'KIDALAPONG',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'KILALAG',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'KINANGAN',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'LACARON',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'LAGUMIT',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'LAIS',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'LITTLE BAGUIO',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'MACOL',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'MANA',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'MANUEL PERALTA',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'NEW ARGAO',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'PANGALEON',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'PANGIAN',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'PINALPALAN',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'SANGAY',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'TALOGOY',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'TICAL',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'TICULON',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'TINGOLO',
    },
    {
        CITY: 'MALITA',
        BARANGAY: 'TUBALAN',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'BATUGANDING',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'CAMAHUAL',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'CAMALIG',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'GOMTAGO',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'KONEL',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'LAKER (SARANGANI SUR)',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'LIPOL',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'MABILA (POB.)',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'PATUCO (SARANGANI NORTE)',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'TAGEN',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'TININA',
    },
    {
        CITY: 'SARANGANI',
        BARANGAY: 'TUCAL',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'BACULIN',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'BANAO',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'BATAWAN',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'BATIANO',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'BINONDO',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'BOBONAO',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'CAMPAWAN',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'DAPNAN',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'KINABLANGAN',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'LAMBAJON',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'LUCOD',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'MAHANUB',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'MIKIT',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'SALINGCOMOT',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'SAN VICTOR',
    },
    {
        CITY: 'BAGANGA',
        BARANGAY: 'SAOQUEGUE',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'CABANGCALAN',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'CAGANGANAN',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'CALUBIHAN',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'CAUSWAGAN',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'MAPUTI',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'MOGBONGCOGON',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'PANIKIAN',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'PINTATAGAN',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'PISO PROPER',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'PUNTA LINAO',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'RANG-AY',
    },
    {
        CITY: 'BANAYBANAY',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BOSTON',
        BARANGAY: 'CAATIHAN',
    },
    {
        CITY: 'BOSTON',
        BARANGAY: 'CABASAGAN',
    },
    {
        CITY: 'BOSTON',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'BOSTON',
        BARANGAY: 'CAWAYANAN',
    },
    {
        CITY: 'BOSTON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BOSTON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BOSTON',
        BARANGAY: 'SIBAJAY',
    },
    {
        CITY: 'BOSTON',
        BARANGAY: 'SIMULAO',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'ALVAR',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'CANINGAG',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'DON LEON BALANTE',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'LAMIAWAN',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'MANORIGAO',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'PALMA GIL',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'PICHON',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'CARAGA',
        BARANGAY: 'SOBRECAREY',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'ABIJOD',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'ALIWAGWAG',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'ARAGON',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'MAGLAHUS',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'MALIBAGO',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'SAN ALFONSO',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'CATEEL',
        BARANGAY: 'TAYTAYAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BAON',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BATOBATO (POB.)',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BITAOGAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CAMBALEON',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'DUGMANON',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'IBA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'LAPU-LAPU',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MAAG',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MANIKLING',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MAPUTI',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SUDLON',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'ANITAP',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'CRISPIN DELA CRUZ',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'DON AURELIO CHICOTE',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'LAVIGAN',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'LUZON',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'MAGDUG',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'MANUEL ROXAS',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'MONSERRAT',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'NANGAN',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'OREGON',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'PUNDAGUITAN',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'SERGIO OSMENA',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'SUROP',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'TAGABEBE',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'TAMBAN',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'TANDANG SORA',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'TIBANBAN',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'TIBLAWAN',
    },
    {
        CITY: 'GOVERNOR-GENEROSO',
        BARANGAY: 'UPPER TIBANBAN',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'CABADIANGAN',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'CALAPAGAN',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'COCORNON',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'CORPORACION',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'DON MARIANO MARCOS',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'ILANGAY',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'LANGKA',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'LANTAWAN',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'LIMBAHAN',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'MACANGAO',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'MARAGATAS',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'MARAYAG',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'NEW VISAYAS',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'TAGBOA',
    },
    {
        CITY: 'LUPON',
        BARANGAY: 'TAGUGPO',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'CAPASNAN',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'CAYAWAN',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'GUZA',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'HOLY CROSS',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'LAMBOG',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'MANREZA',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'NEW TAOKANGA',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'OLD MACOPA',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'SAN FERMIN',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'SAN IGNACIO',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MANAY',
        BARANGAY: 'ZARAGOSA',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'BADAS',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'BOBON',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'BUSO',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'CABUAYA',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'CULIAN',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'DAHICAN',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'DAWAN',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'DON ENRIQUE LOPEZ',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'DON MARTIN MARUNDAN',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'DON SALVADOR LOPEZ',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'DON SALVADOR LOPEZ SR.',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'LANGKA',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'LAWIGAN',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'LIBUDON',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'LUBAN',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'MACAMBOL',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'MAMALI',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'MATIAO',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'MAYO',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'SAINZ',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'SANGHAY',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'TAGABAKID',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'TAGBINONGA',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'TAGUIBO',
    },
    {
        CITY: 'MATI',
        BARANGAY: 'TAMISAN',
    },
    {
        CITY: 'TARRAGONA',
        BARANGAY: 'CABAGAYAN',
    },
    {
        CITY: 'TARRAGONA',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'TARRAGONA',
        BARANGAY: 'DADONG',
    },
    {
        CITY: 'TARRAGONA',
        BARANGAY: 'JOVELLAR',
    },
    {
        CITY: 'TARRAGONA',
        BARANGAY: 'LIMOT',
    },
    {
        CITY: 'TARRAGONA',
        BARANGAY: 'LUCATAN',
    },
    {
        CITY: 'TARRAGONA',
        BARANGAY: 'MAGANDA',
    },
    {
        CITY: 'TARRAGONA',
        BARANGAY: 'OMPAO',
    },
    {
        CITY: 'TARRAGONA',
        BARANGAY: 'TOMOAONG',
    },
    {
        CITY: 'TARRAGONA',
        BARANGAY: 'TUBAON',
    }
];
